import { Icons } from '@/components/Shares/Icons';
import classes from '@/components/Shares/Selected.module.css';
import { type Languages, languages } from '@/i18n/i18n-config';
import { Avatar, Box, Button, Group, Menu, ScrollArea, Text } from '@mantine/core';
import { useState } from 'react';
export const LanguageSelected: React.FC = () => {
  const [language, setLanguage] = useState<Languages>(languages[0]);
  const [menuIsOpen, setMenuIsOpen] = useState<boolean>(false);
  return <Menu shadow="md" width={320} withinPortal={false} position="bottom-end" classNames={classes} onChange={() => setMenuIsOpen(!menuIsOpen)}>
      <Menu.Target>
        <Button h={40} p={0} variant="transparent" style={{
        pointerEvents: 'auto'
      }} classNames={{
        section: classes.section
      }} rightSection={<Box mod={{
        active: menuIsOpen
      }} className={classes.iconStyle}>
              <Icons className="icon-pr-line-chevron-down" fontSize={24} />
            </Box>}>
          <Group gap={5}>
            <Avatar src={language.icon} size={24} variant="transparent" />
            <Text miw={30} fz="xs" tt="uppercase" c="var(--text-dark)" fw={700}>
              {language.code}
            </Text>
          </Group>
        </Button>
      </Menu.Target>

      <Menu.Dropdown style={{
      pointerEvents: 'auto'
    }}>
        <ScrollArea h={280} offsetScrollbars classNames={classes}>
          {languages.map(item => <Menu.Item key={item.name} mod={{
          active: item.code === language.code
        }} leftSection={<Avatar variant="transparent" src={item.icon} size={24} />} rightSection={item.code === language.code && <Icons className="icon-pr-line-checked" fontSize={20} color="var(--text-prime)" />} onClick={() => setLanguage(item)}>
              <Text fz="xs" fw={700}>
                {item.name}
              </Text>
            </Menu.Item>)}
        </ScrollArea>
      </Menu.Dropdown>
    </Menu>;
};